import React from 'react';
import styled, { css } from 'styled-components';
import ArrowLeft from 'src/assets/arrow-left';

type StepHeaderProps = React.HTMLAttributes<HTMLDivElement> & {
  title?: string;
  stepHeading?: string;
  stepDescription?: string;
  onBack?: () => void;
  showBackButton?: boolean;
};

export const StepHeader = ({
  title = 'Free Medical Evaluation',
  stepHeading,
  stepDescription,
  onBack,
  showBackButton = true,
  ...rest
}: StepHeaderProps): JSX.Element => (
  <Header {...rest}>
    <TitleContainer>
      <BackButtonContainer>
        {showBackButton && onBack && (
          <BackIconButton onClick={onBack}>
            <ArrowLeft />
          </BackIconButton>
        )}
      </BackButtonContainer>

      {title && <HeaderTitle>{title}</HeaderTitle>}
    </TitleContainer>

    <StepContainer>
      <StepHeading>{stepHeading}</StepHeading>
      <StepDescription>{stepDescription}</StepDescription>
    </StepContainer>
  </Header>
);

const Header = styled.div`
  ${({ theme: { spaces } }) => css`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-between;
    padding: ${spaces[4]} ${spaces[4]} 0};
    margin-bottom: ${spaces[8]};
  `}
`;

const TitleContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  position: relative;
`;

const BackButtonContainer = styled.div`
  position: absolute;
  left: 0;
  top: 0;
`;

const BackIconButton = styled.button`
  background: none;
  border: none;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;

  svg {
    width: 20px;
    height: 20px;
  }
`;

const HeaderTitle = styled.h2`
  margin-bottom: ${({ theme: { spaces } }) => spaces[4]};
  text-align: center;
  font-size: 20px;
  font-weight: 600;
  flex: 1;
`;

const StepContainer = styled.div`
  ${({ theme: { spaces } }) => css`
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: ${spaces[2]};
    margin-top: ${spaces[6]};
    padding: 0 ${spaces[4]};
  `}
`;

const StepHeading = styled.h3`
  margin: 0;
  font-size: 24px;
  font-weight: 600;
`;

const StepDescription = styled.p`
  margin: 0;
  font-size: 14px;
  text-align: center;
`;
